
import { getToken } from '@/utils/auth'
import Config from '@/settings'

// # 导入子路由并创建
import subroute from './assets/menu_router.json'
const routers = [];
for (const index in subroute) {
  const components = subroute[index].components;
  for (const i in components) {
    const item = components[i];
    const component = item.component;
    item["component"] = () => import(`${component}`)
    routers.push(item);
  }
}

// # 用户中心
const userCenter = {
  path: "/user/center",
  meta: {
    title: "用户中心"
  },
  component: () => import("./views/adminer/UserCenter")
}
routers.push(userCenter);

// # 调整资金
const userGold = {
  path: "/user/gold",
  name: 'user_gold',
  meta: {
    title: "调整资金"
  },
  component: () => import("./views/adminer/user/UserGold")
}
routers.push(userGold);

// # 添加交易对
const addsymbol = {
  path: "/market/addsymbol",
  name: 'addsymbol',
  meta: {
    title: "添加交易对"
  },
  component: () => import("./views/adminer/market/CoinsAddSymbol")
}
routers.push(addsymbol);

// # Vue>= 3.0 创建路径 createWebHashHistory createWebHistory
import { createWebHashHistory, createRouter } from 'vue-router'
const history = createWebHashHistory()
const router = createRouter({
  history,
  routes: [
    // # 后台主页面路由
    {
      path: '/',
      name: 'adminer',
      redirect: '/home',
      component: () => import("./views/Adminer"),
      children: routers
    },
    // # 登录页面路由
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import("./views/Login")
    },
    
    {
      path: '/app/install',
      name: 'app_install',
      meta: {
        title: '应用安装'
      },
      component: () => import("./views/AppInstall")
    },

    // # 404 页面
    // # 参考 https://blog.csdn.net/qq_42723113/article/details/119846710
    {
      path: '/:pathMatch(.*)*',
      meta: {
        title: 'Error 404'
      },
      component: () => import("./views/error/404")
    }
  ]
});

/*
router.beforeResolve((to, from, next) => {
    next()
})
*/

// # 参考
// # https://blog.csdn.net/xiaodi520520/article/details/93041839
router.beforeEach((to, from, next) => {
  // # 设置页面标题
  if (to.meta.title) {
    document.title =  Config.title + ' - ' + to.meta.title
  }

  // # The is login page
  const isLogin = to.path === '/login'
  const token = getToken()
  if (token) {
    // # 已登录且要跳转的页面是登录页
    if (isLogin) {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (isLogin) {
      next()
    } else {
      next({path : '/login'})
    }
  }
});

// # 导出路由
export default router